import React from 'react';

export default function VadoLogoLogin() {
    return (
        <span style={{ fontFamily: 'Open Sans Condensed', fontSize: '38px', color: 'white' }}>VADO</span>
    );
}
